<!--
categories menu
https://stackoverflow.com/questions/58011307/svelte-js-how-to-rerender-child-components-with-new-props
AT
08.06.21
-->

<script>
	import { onMount } from 'svelte'
	import CategoriesWrapper from './components/categories-wrapper.svelte'

	let parents=[]

	onMount(async() => {
		await window.Categories.get()
		let rootParent = window.Categories.find( {"level":1} )[0].parent
		parents.push(rootParent)
		parents = parents //for reactivity!
	})

	function truncateParents(uid){
		//finding the selected item
		let item = window.Categories.find({"uid":uid})[0]

		//removing all parents with level >= selectedLevel
		parents.splice( item.level )

		//this output is added for reactivity only
		return parents
	}

	function handleSelect(event){
		truncateParents(event.detail.parent)

		//adding selected parent
		parents.push(event.detail.parent)

		//removing dupes
		parents = [...new Set(parents)]
	}

	function handleDeselect(event){
		parents = truncateParents(event.detail.uid)
	}
</script>

<div id="categories-menu-inner" class="flex">
	{#key parents}
		<CategoriesWrapper parents={ parents } on:select={ handleSelect } on:deselect={ handleDeselect }/>
	{/key}
</div>